var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMilestoneLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1386,
    height: 15,
    viewBox: "0 0 1386 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3325",
    "data-name": "Group 3325",
    transform: "translate(-267.5 -2104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M4430.5,3248.5h1386",
    transform: "translate(-4163 -1138)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    strokeDasharray: 5,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    transform: "translate(303 2104)",
    fill: "#ed193a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 6,
    cy: 6.5,
    rx: 6,
    ry: 6.5,
    transform: "translate(954 2106)",
    fill: "#ed193a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    transform: "translate(1606 2106)",
    fill: "#ed193a"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestoneLine);
export default __webpack_public_path__ + "static/media/milestone-line.f0fb1f867bc44abc45ce12943595a68a.svg";
export { ForwardRef as ReactComponent };